import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';

@Component({
  selector: 'app-selectfields',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule
  ],
  templateUrl: './selectfields.html',
  styleUrl: './selectfields.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Selectfields {
  @Input() label!: string;
  @Input() placeholder = 'None';
  @Input() options: { label: string; value: any }[] = [];
  @Input() control!: FormControl;
  @Input() required = false;
}
